<template>
  <v-app>
    <v-app-bar app clipped-left height="64" class="bar">
      <v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
      <!-- <v-btn v-show="!isshowhamberger" icon @click="goBack()">
        <v-icon>mdi-arrow-left</v-icon>
      </v-btn> -->
      <v-toolbar-title id="galasio-font" class="text-center">
        <span class="headline font-weight-bold primary--text text-uppercase">TRAMS</span>
        <span class="caption font-weight-bold bloody--text text--darken-2 d-sm-flex d-none">
          TRansport Accident
          <br />Management System: TRAMS
        </span>
      </v-toolbar-title>
      <v-divider class="mx-4 d-none d-sm-flex" vertical></v-divider>
      <span class="subtitle-2 dense-line-height d-none d-sm-flex">
        ระบบรายงานข้อมูลอุบัติเหตุ
        <br />ของกระทรวงคมนาคม
      </span>
      <v-spacer></v-spacer>
      <v-btn v-if="is_login" rounded color="primary" class="ml-3" @click="alertDialog = true">
        <span class="mx-4">{{ username }}</span>
      </v-btn>
      <LoginDialog v-else @login="loginByPassword" :loginResult="loginResult" />
    </v-app-bar>
    <!-- Navagation Drawer Start-->
    <v-navigation-drawer v-model="drawer" app temporary>
      <template v-slot:prepend v-if="is_login">
        <v-list-item two-line>
          <v-list-item-avatar>
            <img src="./assets/images/logo/logo@3x.png" />
          </v-list-item-avatar>

          <v-list-item-content>
            <v-list-item-title>{{ username }}</v-list-item-title>
            <!-- <v-list-item-subtitle>Logged In</v-list-item-subtitle> -->
          </v-list-item-content>
        </v-list-item>
      </template>

      <v-divider></v-divider>

      <v-list nav dense>
        <v-list-item-group v-model="navGroup" active-class="primary--text text--accent-4">
          <template v-for="(item, index) in navItems">
            <v-list-item
              :key="'nav-' + index"
              v-if="item.allow || is_admin"
              @click="gotoPage(item.page, item.icon == 'fa-question' || item.icon == 'fa-server')"
              :value="item.page"
            >
              <v-list-item-icon>
                <v-icon>{{ item.icon }}</v-icon>
              </v-list-item-icon>

              <v-list-item-content>
                <v-list-item-title class="py-1">{{ item.text }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </template>
        </v-list-item-group>
      </v-list>
      <v-divider></v-divider>

      <v-list nav dense>
        <v-list-item @click="logout" v-if="is_login">
          <v-list-item-icon>
            <v-icon>lock</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title class="py-1">ออกจากระบบ</v-list-item-title>
            <!-- class="grey--text text--darken-1" -->
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>
    <!-- Navagation Drawer End-->
    <v-main>
      <router-view
        :userLogin="is_login"
        :userPermission="permission"
        :userRole="role"
        :userAdmin="is_admin"
        @sethambergervisible="showhamberger"
        @gobacktolink="gobacktolink"
        @unauthorized="unauthorized"
      ></router-view>
    </v-main>
    <LoadingScreen v-show="isLoading" />
    <v-flex class="flex-dialog">
      <AlertDialog
        v-model="alertDialog"
        :cancel-btn="true"
        :hide-icon="true"
        v-on:ok-btn-click="
          logout();
          alertDialog = false;
        "
        v-on:cancel-btn-click="alertDialog = false"
        >ออกจากระบบ</AlertDialog
      >
    </v-flex>
    <v-flex class="flex-dialog">
      <AlertDialog
        v-model="contactDialog"
        :cancel-btn="false"
        :hide-icon="true"
        v-on:ok-btn-click="contactDialog = false"
      >
        <p class="text-center h6 bloody--text text--darken-2">
          สำนักงานปลัดกระทรวงคมนาคม ศูนย์ไอซีที
        </p>
        <hr />
        <br />
        <p>
          เลขที่ 38 ถนนราชดำเนินนอก แขวงวัดโสมนัส<br />
          เขตป้อมปราบศัตรูพ่าย กรุงเทพมหานคร 10100<br />
          เบอร์โทรศัพท์ 0-2283-3193,0-2283-3442 (คุณสุเมธ วนาลีสุขสันต์)
        </p>
      </AlertDialog>
    </v-flex>
  </v-app>
</template>

<script>
import LoginDialog from './components/LoginDialog.vue';
import LoadingScreen from './components/LoadingScreen.vue';
import AlertDialog from './components/global/AlertDialog';

const qs = require('qs');

export default {
  name: 'App',
  components: {
    LoginDialog,
    LoadingScreen,
    AlertDialog
  },
  data: () => ({
    alertDialog: false,
    contactDialog: false,
    username: null,
    is_login: true,
    is_admin: false,
    loginResult: null,
    drawer: false,
    navGroup: 'home',
    role: '',
    permission: {},
    isLoading: false,
    isshowhamberger: true,
    backlink: ''
  }),
  created() {
    let amountAjaxPending = 0;

    this.axios.interceptors.request.use(
      config => {
        if (!(config.params && config.params.lazy)) {
          this.setLoading(true);
          amountAjaxPending++;
        }
        if (this.is_login) {
          config.headers.Authorization = `Bearer ${localStorage.getItem('access_token')}`;
        }
        return config;
      },
      error => {
        amountAjaxPending--;
        this.setLoading(false);
        return Promise.reject(error);
      }
    );

    this.axios.interceptors.response.use(
      response => {
        if (!(response.config && response.config.params && response.config.params.lazy)) {
          amountAjaxPending--;
        }
        if (amountAjaxPending == 0) {
          this.setLoading(false);
        }

        return response;
      },
      error => {
        amountAjaxPending--;
        this.setLoading(false);
        return Promise.reject(error);
      }
    );
  },
  mounted() {
    this.checkLoginState();
    this.initNavCurrentPage();
  },
  methods: {
    showhamberger(value) {
      this.isshowhamberger = value;
    },
    gobacktolink(value) {
      this.isshowhamberger = false;
      this.backlink = value;
    },
    goBack() {
      if (this.backlink) {
        this.$router.push({ name: this.backlink });
      } else {
        window.history.back();
      }
    },
    checkLoginState() {
      const accessToken = localStorage.getItem('access_token');
      // const refreshToken = localStorage.getItem('refresh_token');
      const username = localStorage.getItem('username');

      if (/*accessToken && refreshToken && */username) {
        this.username = username;
        this.is_admin = localStorage.getItem('is_admin') == 'true';
        this.role = localStorage.getItem('role');
        this.permission = JSON.parse(localStorage.getItem('permission'));
        this.checkToken(accessToken);
      } else {
        console.log('No Login');
        this.is_login = false;
      }
    },
    login(data) {
      const url = `${process.env.VUE_APP_SERVICE_API_URL}/authen/token`;
      const scope = this;
      let messages = null;

      this.axios
        .post(url, qs.stringify(data))
        .then(response => {
          scope.is_login = response.status === 200;

          if (data.username) {
            localStorage.setItem('username', data.username);
            scope.username = data.username;
          }

          if (scope.is_login) {
            scope.is_admin = response.data.is_admin;
            scope.role = response.data.role;
            scope.permission = response.data.permission;
            localStorage.setItem('is_admin', scope.is_admin);
            localStorage.setItem('role', scope.role);
            localStorage.setItem('permission', JSON.stringify(scope.permission));
            localStorage.setItem('access_token', response.data.access_token);
            localStorage.setItem('refresh_token', response.data.refresh_token);
            localStorage.setItem('user_id', response.data.user_id);
            localStorage.setItem('email', response.data.user_email);
            localStorage.setItem('department', response.data.department);
            localStorage.setItem('fullname', response.data.fullname || '-');
            if (data.grant_type == 'password') location.reload();
          } else {
            messages = response.data.error;
            scope.logout();
          }

          scope.loginResult = {
            grant_type: data.grant_type,
            result: scope.is_login,
            messages
          };
        })
        .catch(function(error) {
          messages = error.response ? error.response.data.message : error.message;
          scope.logout();
          console.log(error);

          scope.loginResult = {
            grant_type: data.grant_type,
            result: scope.is_login,
            messages
          };
        });
    },
    loginByPassword(username, password) {
      const data = {
        username,
        password,
        grant_type: 'password'
      };
      this.login(data);
    },
    checkToken(token) {
      const data = {
        access_token: token
      };
      const url = `${process.env.VUE_APP_SERVICE_API_URL}/authen/check`;
      const scope = this;

      this.axios
        .post(url, qs.stringify(data))
        .then(response => {
        })
        .catch(function(error) {
          scope.logout();
        });
    },
    logout() {
      this.setLoading(true);
      this.is_admin = this.is_login = false;
      this.permission = {};
      localStorage.removeItem('access_token');
      localStorage.removeItem('refresh_token');
      localStorage.removeItem('username');
      localStorage.removeItem('user_id');
      localStorage.removeItem('email');
      localStorage.removeItem('department');
      localStorage.removeItem('fullname');
      localStorage.removeItem('is_admin');
      localStorage.removeItem('role');
      localStorage.removeItem('permission');
      if (location.pathname.indexOf('main-dashboard') == -1) {
        this.$router.push({ name: 'main_dashboard' });
      } else {
        location.reload();
      }
    },
    unauthorized() {
      this.is_admin = this.is_login = false;
      this.permission = {};
      localStorage.removeItem('access_token');
      localStorage.removeItem('refresh_token');
      localStorage.removeItem('username');
      localStorage.removeItem('user_id');
      localStorage.removeItem('email');
      localStorage.removeItem('department');
      localStorage.removeItem('fullname');
      localStorage.removeItem('is_admin');
      localStorage.removeItem('role');
      localStorage.removeItem('permission');
    },
    gotoPage(page, isFile) {
      if (isFile) {
        window.open(`${page}`, '_blank');
      } else if (page == 'contact') {
        this.contactDialog = true;
      } else {
        this.$router.push({ name: page });
      }
    },
    initNavCurrentPage() {
      this.navGroup = this.$route.name;
    },
    setLoading(isLoading) {
      this.isLoading = isLoading;
      if (isLoading) this.initNavCurrentPage();
    }
  },
  computed: {
    currentPage() {
      return this.$route.name;
    },
    navItems() {
      const monthName = [
        'Jan',
        'Feb',
        'Mar',
        'Apr',
        'May',
        'Jun',
        'Jul',
        'Aug',
        'Sep',
        'Oct',
        'Nov',
        'Dec'
      ];
      const lastWeek = new Date(new Date() - 60 * 60 * 24 * 1000 * 7);
      const lastWeekString = `${lastWeek.getDate()}-${
        monthName[lastWeek.getMonth()]
      }-${lastWeek.getFullYear()}`;
      return [
        {
          icon: 'home',
          text: 'หน้าหลัก',
          page: 'main_dashboard',
          allow: true
        },
        {
          icon: 'map',
          text: 'แผนที่',
          page: 'map',
          allow: true
        },
        {
          icon: 'info',
          text: 'รายงาน',
          page: 'dashboard_report',
          allow: true
        },
        {
          icon: 'info',
          text: 'สรุปสถานการณ์อุบัติเหตุ',
          page: 'report-executive',
          allow: true
        },
        {
          icon: 'directions_railway',
          text: 'เพิ่มข้อมูลอุบัติเหตุ (รฟท.)',
          page: 'addinfo_train',
          allow: this.permission.is_allow_add_train
        },
        {
          icon: 'directions_bus',
          text: 'เพิ่มข้อมูลอุบัติเหตุ (ขสมก.)',
          page: 'addinfo_bus',
          allow: this.permission.is_allow_add_bus
        },
        {
          icon: 'description',
          text: 'รายการอุบัติเหตุ',
          page: 'report',
          allow: this.is_login
        },
        {
          icon: 'assignment',
          text: 'รายการข้อมูลซ้ำ',
          page: 'duplicate',
          allow: this.is_login
        },
        {
          icon: 'account_circle',
          text: 'ตั้งค่า',
          page: 'setting',
          allow: this.permission.is_allow_setting
        },
        {
          icon: 'fa-server',
          text: 'สถานะระบบ',
          page: `ws/public/service/status?token=${localStorage.getItem(
            'access_token'
          )}&start=${lastWeekString}`,
          allow: this.permission.is_allow_setting
        },
        {
          icon: 'fa-question',
          text: 'คู่มือการใช้งาน รฟท.',
          page: 'manual_srt.pdf',
          allow: this.permission.is_allow_add_train
        },
        {
          icon: 'fa-question',
          text: 'คู่มือการใช้งาน ขสมก.',
          page: 'manual_bmta.pdf',
          allow: this.permission.is_allow_add_bus
        },
        {
          icon: 'fa-phone',
          text: 'ติดต่อสอบถาม',
          page: 'contact',
          allow: this.is_login
        }
      ];
    }
  }
  // watch: {
  //   navGroup(val) {
  //     console.log(val);
  //   },
  //   is_login(val) {
  //     console.log(val);
  //   },
  //   loginResult(val) {
  //     console.log(val);
  //   }
  // }
};
</script>
<style lang="scss" scope>
@import url('https://fonts.googleapis.com/css?family=Gelasio&display=swap');
@import './assets/css/main.css';
.dense-line-height {
  line-height: 1.2rem;
}
.disable-events {
  pointer-events: none;
}
#galasio-font > span {
  font-family: 'Gelasio', serif !important;
  line-height: 15px;
}
</style>
